import { render, staticRenderFns } from "./DiceAnimator.vue?vue&type=template&id=46b23e22&scoped=true&lang=pug&"
import script from "./DiceAnimator.vue?vue&type=script&lang=ts&"
export * from "./DiceAnimator.vue?vue&type=script&lang=ts&"
import style0 from "./DiceAnimator.vue?vue&type=style&index=0&id=46b23e22&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b23e22",
  null
  
)

component.options.__file = "DiceAnimator.vue"
export default component.exports